import {Type} from 'class-transformer';
import {serializeType} from '../classes/common';

export class ContractSummary {

  id: number;
  contractTitle: string;
  description: string;
  subtype: string;
  previousContractTitle: string;
  startDate: string;
  endDate: string;
  endDateWithAllOptions: string;
  totalValue: number;
  hasContractLaborCategories: boolean;
  hasClins: boolean;
  customerBusinessName: string;
  customerId: number;
  currentStatusName: string;
  @Type(serializeType(ContractSummary)) children: ContractSummary[];
  txnNumber: string;
  escalationRate: number;
  pdfTemplateId: number;
}
